import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let SpeakerIcon = (props) => {
  props = Object.assign({viewBox: '0 0 70 70'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M35,37.4"/>
        <path d="M35,37.4"/>
        <path d="M49.8,61.5H20.2c-3.8,0-6.9-3.1-6.9-6.9V15.4c0-3.8,3.1-6.9,6.9-6.9h29.5c3.8,0,6.9,3.1,6.9,6.9v39.3
		C56.6,58.4,53.5,61.5,49.8,61.5z M20.2,11.3c-2.2,0-4,1.8-4,4v39.3c0,2.2,1.8,4,4,4h29.5c2.2,0,4-1.8,4-4V15.4c0-2.2-1.8-4-4-4
		L20.2,11.3L20.2,11.3z"/>
        <path d="M35,45.3c-7.9,0-14.3-6.4-14.3-14.3S27.1,16.7,35,16.7S49.3,23.1,49.3,31S42.9,45.3,35,45.3z M35,19.5
		c-6.3,0-11.5,5.2-11.5,11.5S28.7,42.5,35,42.5S46.5,37.3,46.5,31S41.3,19.5,35,19.5z"/>
        <path d="M35,32.7"/>
        <path d="M35,32.7"/>
        <path d="M35,35.8c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8C39.8,33.7,37.6,35.8,35,35.8z M35,29.1
		c-1.1,0-1.9,0.9-1.9,1.9c0,1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9C36.9,30,36.1,29.1,35,29.1z"/>
      </g>
    </SvgIcon>
  );
};

SpeakerIcon.displayName = 'SpeakerIcon';
SpeakerIcon.muiName = 'SvgIcon';

export default SpeakerIcon;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/icons/Speaker.Icon.js